export const DrsFile = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
    	drs_files:'DRS FILES',
    	add_drs_file:'Add DRS File',
        edit_drs_file:'Edit DRS File',
        drs_file:'DRS File',
    	s_no:'DRS.No',
    	name:'Name',
    	email:'Email',
        phone:'Phone',
        country:'Country',
        is_active:'Is Active',
        record_status:'Record Status',
    	action:'Action',
    	status:'Status',
    	reset:'Reset',
    	subject:'Subject',
        zone:'Zone',
        site:'Site',
        consumption:'Consumption',
        file_format:'Only allowed xls, xlsx format',
    	template_information:'Template Information',
    },

	ar: {
    	drs_files:'ملفات DRS',
    	add_drs_file:'أضف ملف DRS',
        edit_drs_file:'تحرير ملف DRS',
        drs_file:'ملف DRS',
    	s_no:'DRS لا',
    	name:'الاسم',
    	email:'البريد الالكتروني',
        phone:'الهاتف',
        country:'الدولة',
        is_active:'نشط',
        record_status:'سجل الحالة',
    	action:'العمل',
    	status:'الحالة',
    	reset:'إعادة ضبط',
    	subject:'الموضوع',
        zone:'المنطقة',
        site:'الموقع',
        consumption:'الاستهلاك',
        file_format:'يسمح فقط بتنسيق xls xlsx',
    	template_information:'معلومات النموذج',
    },
}
